// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfiloDatiCard_root__DXH4n","title":"ProfiloDatiCard_title__xhaic","content":"ProfiloDatiCard_content__kwBoi","rotation":"ProfiloDatiCard_rotation__rOQJ8"};